var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIncidentCategoryProduction = function SvgIncidentCategoryProduction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "incident_category-production")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.54
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-Icons-Copy",
    transform: "translate(-79.000000, -589.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4922602,596.5 L82.9922602,589.984375 L80.9922602,589.984375 L80.4922602,596.5 L83.4922602,596.5 Z M92.5078852,604.015625 L92.5078852,592.71875 L88.2266352,597 L88.2266352,592.71875 L83.9297602,597 L79.4922602,597 L79.4922602,604.015625 L92.5078852,604.015625 Z M87.5078852,601.578125 L85.4922602,601.578125 L85.4922602,599.578125 L87.5078852,599.578125 L87.5078852,601.578125 Z M90.5078852,601.578125 L88.5078852,601.578125 L88.5078852,599.578125 L90.5078852,599.578125 L90.5078852,601.578125 Z",
    id: "incident_category-production"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIncidentCategoryProduction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/incident_category-production.99358377.svg";
export { ForwardRef as ReactComponent };